import { schema } from 'normalizr';

const CustomerTypeSchema = new schema.Entity('customerTypes', {});
const CustomerPreferencesSchema = new schema.Entity('customerPreferences', {});
const CustomerOptionsSchema = new schema.Entity('customerOptions', {});
const CustomerThirdPartySchema = new schema.Entity('customerThirdParties', {});
const CustomerSchema = new schema.Entity('customers', {
  preferences: CustomerPreferencesSchema,
  options: CustomerOptionsSchema,
});

export { CustomerSchema, CustomerTypeSchema, CustomerThirdPartySchema };
